// Column Gap Frontend JavaScript
document.addEventListener('DOMContentLoaded', function() {
    // Apply column gap from data attribute
    function applyColumnGap() {
        const columnsBlocks = document.querySelectorAll('.wp-block-columns.is-style-gap[data-column-gap]');
        
        columnsBlocks.forEach(function(block) {
            const gapValue = block.getAttribute('data-column-gap');
            if (gapValue) {
                block.style.setProperty('--column-gap', gapValue);
                // console.log('Column Gap: Applied gap', gapValue, 'to columns block');
            }
        });
    }
    
    // Apply on page load
    applyColumnGap();
    
    // Apply when new content is loaded (for dynamic content)
    const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.type === 'childList') {
                applyColumnGap();
            }
        });
    });
    
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
});
